import { Box, styled } from '@mui/material';
import { ModalPanelBody, ModalPanelTabType } from 'redesign';
import { FlexWorkerProfileData, SkillType } from '@types';
import { ProfileCertificates } from './profile-certificates';
import { ProfileHeader } from './profile-header';
import { ProfileQualifications } from './profile-qualifications';
import { ProfileWorkExperienceTab } from '../../../../../../shared/components/common/work-experience/work-experience-tab';

const Profile = ({ data, id }: { data: FlexWorkerProfileData; id: string }) => {
  const options = getPanelBodyOptions(data, id);

  return (
    <WrapperBoxProfile>
      <ProfileHeader data={data} />
      <ModalPanelBody tabs={options} />
    </WrapperBoxProfile>
  );
};

const WrapperBoxProfile = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(8)} 0 ${theme.spacing(8)} ${theme.spacing(8)}`,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

const getPanelBodyOptions = (data: FlexWorkerProfileData, id: string): ModalPanelTabType[] => {
  const options: ModalPanelTabType[] = [
    {
      id: 'Certificates',
      tabLabel: 'Certificaten',
      element: <ProfileCertificates flexWorkerId={id} />,
    },
    {
      id: 'Skills',
      tabLabel: 'Vaardigheden',
      element: (
        <ProfileQualifications
          data={data.qualifications.filter((q) => q.category !== SkillType.APPAREL)}
        />
      ),
    },
    {
      id: 'Apparel',
      tabLabel: 'Kledingvoorschriften',
      element: (
        <ProfileQualifications
          data={data.qualifications.filter((q) => q.category === SkillType.APPAREL)}
        />
      ),
    },
  ];

  if (!data.partnerName) {
    options.push({
      id: 'Werkervaring',
      tabLabel: 'Werkervaring',
      element: <ProfileWorkExperienceTab workExperiences={data.workExperiences} />,
    });
  }

  return options;
};

export { Profile };
